<header>
  <h1  routerLink="/" routerLinkActive="active">
    <small>Welcome to the</small>Massachusetts State House
  </h1>
  <app-clock-widget class="clockWidget"></app-clock-widget>
</header>
<main>
  @if (hasRoute('')) {
    <app-home class="homeContainer"></app-home>
  }
</main>
<div [@slideInOut]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"
    (activate)="onRouterOutletActivate(outlet)"
    (deactivate)="onRouterOutletDeactivate()">
  </router-outlet>
</div>
@if (!home()) {
  <footer class="col-12">
    <nav class="nav-wrapper">
      <ul class="footerText">
        <li>
          <a routerLink="/">
            <fa-icon class="fa-2xl" [icon]="faHome"></fa-icon>
          </a>
        </li>
        <li>
          <a routerLink="/directory" routerLinkActive="active">
            Room Directory
          </a>
        </li>
        <li>
          <a routerLink="/events-and-hearings" routerLinkActive="active">
            Events & Hearings
          </a>
        </li>
        <li>
          <a routerLink="/about" routerLinkActive="active">
            About the State House
          </a>
        </li>
      </ul>
    </nav>
  </footer>
}
